module.exports = __webpack_public_path__ + "static/AMDesignlovin-5a6d7f93a16353cfc4f57592e9050a23.jpg";